export default __webpack_public_path__ + "static/media/IconDesc_NuclearCell.256.a12eb398.png";